/**
 * @description Capitalize the first letter of a string.
 * @param stringVal
 * @returns String
 */
function firstCapitalLetter(stringVal: string) {
	try {
		return stringVal.charAt(0).toUpperCase() + stringVal.slice(1);
	} catch (error) {
		return stringVal;
	}
}

/**
 * @description Join an string.
 * @param text String
 * @param addition String
 * @returns String
 */
function joinString(text: string, addition = "", camelCase = false) {
	let result = `${text}${addition}`.replace(/\s(.)/g, (word) => {
		return word.toUpperCase();
	});
	result = result.replace(/\s/g, "");

	if (camelCase) {
		result = result.replace(/^(.)/, (word) => {
			return word.toLowerCase();
		});
	}
	return result;
}

const stringBetweenStrings = (start: string, end: string, text: string) => {
	if (text) {
		const from = text.indexOf(start) + start.length;
		return text.substring(from + 1, text.indexOf(end, from));
	}
	return "";
};

// Previously also known as getSectionErrorKey
const getErrorKey = (section: string, tab: string | null = null): string => {
	const error = tab ? `${section}_${tab}` : section;
	return `${error}_error`.trim().toLowerCase();
};

export { firstCapitalLetter, getErrorKey, joinString, stringBetweenStrings };
